var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Quote Marks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,27.8C0,15.3,5.8,6.3,16.7,0l3.6,6.1C12.5,11.3,8.4,16.7,8.4,25.6c0.5-0.2,0.9-0.2,1.4-0.2c4.4,0,8.3,2.8,8.3,8 c0,5.3-3.4,8.6-8.3,8.6C3.6,42.1,0,37.1,0,27.8z M27.7,27.8c0-12.5,5.8-21.6,16.7-27.8L48,6.1c-7.8,5.2-11.9,10.6-11.9,19.5 c0.5-0.2,0.9-0.2,1.4-0.2c4.4,0,8.3,2.8,8.3,8c0,5.3-3.4,8.6-8.3,8.6C31.3,42.1,27.7,37.1,27.7,27.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteMark);
export default __webpack_public_path__ + "static/media/quote-mark.6b8bc77c58cfb5eadc6dc1e05a7b87b8.svg";
export { ForwardRef as ReactComponent };